import { render, staticRenderFns } from "./BaselineCompareDetails.vue?vue&type=template&id=7134fa38&scoped=true"
import script from "./BaselineCompareDetails.vue?vue&type=script&lang=js"
export * from "./BaselineCompareDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7134fa38",
  null
  
)

export default component.exports